var _style, _polygon, _polygon2, _polyline, _polygon3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIzzi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "57.9px",
    height: "23.5px",
    viewBox: "0 0 57.9 23.5",
    style: {
      enableBackground: "new 0 0 57.9 23.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00BCB4;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#EC6907;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#D7006D;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFCE00;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3.7,19.4 3.7,16 0.1,16 0.1,19.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "12,3.5 12,0.1 8.5,0.1 8.5,3.5 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "58,4.4 54.4,4.4 54.4,7.8 58,7.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "46.1,20.2 46.1,23.6 49.7,23.6 49.7,20.2 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.985 3.94)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "0.4,15.4 0.4,3.8 4,3.8 4,15.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.7,3.9l-6.4,6.8c-0.7,0.7-1.4,1.4-1.4,1.4h0c0,0,1,0,2.3,0h5.4v3.3H7v-3.4l6.7-7C14.2,4.5,15,3.8,15,3.8   s-1.4,0-2.3,0H7.2V0.5h12.5V3.9z M22.4,12.1l6.4-6.9c0.7-0.7,1.4-1.4,1.4-1.5c0,0-1,0-2.3,0h-5.5V0.5h12.6v3.3l-6.7,7.1   c-0.5,0.6-1.4,1.3-1.4,1.3s1.4,0,2.4,0h5.5v3.4H22.4V12.1L22.4,12.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "38.2,12.1 38.2,0.5 41.7,0.5 41.7,12.1  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIzzi);
export default __webpack_public_path__ + "static/media/Logo_Izzi.768332390ef195e3e654b7c8886e0ad7.svg";
export { ForwardRef as ReactComponent };